module.exports = __webpack_public_path__ + "img/super-draw.97b0dd56.webp";